<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <h2>Editando colheita</h2>
      </div>
    </div>

    <div ng-include="'views/colheitas/_detalhes.html'"></div>
  </div>
</page-data-manager>
